<template>
    <div class="cstm_vuexy_table table-responsive">
        <table class="w-full">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Total</th>
                    <th>Issue Date</th>
                    <th>Due Date</th>
                    <th>Balance</th>


                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(eachData, index) in clientsListInvoices" :key="index">
                    <td>
                        {{ eachData.invoice_id }}
                    </td>
                    <td>
                        {{ eachData.amount }}
                    </td>
                    <td>
                        {{ eachData.created_at }}
                    </td>
                    <td>
                        {{ eachData.period }}
                    </td>
                    <td>
                        {{ eachData.payment_mode }}
                    </td>

                    <td>
                        <a style="cursor: pointer;" class="primary">View Payslip</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {  fetchStudentFinanceBySearch } from '@/api/finance'
export default {
  mounted () {
    this.fetchInvoiceListBySearch()
  },
  data () {
    return {
      meta: {
        current_page: 1,
        has_next: true,
        limit: 5,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      clientsListInvoices:[],
      payslips: [
        {
          id: 1,
          date: 'Thursday 8th March, 2022',
          period: '1/3/2022 - 7/3/2022',
          method: 'Cash',
          rate: '£20',
          minimum_daily_guaranteed: '2',
          total_hours_worked: '4.5',
          total_guaranteed_hours: '4.5',
          total_payment: '£90.00'
        }
      ]
    }
  },
  methods: {
    async fetchInvoiceListBySearch () {
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          client_user_id:this.$route.params.client_id
        }

        const responseData = await fetchStudentFinanceBySearch(
          payload,
          this.meta.current_page,
          20,
          {}
        )
        this.clientsListInvoices = responseData.data.data.invoices
        this.meta = responseData.data.data.meta
      } catch (e) {
        //
      }
    }
  }
}
</script>
